import useLocalStorageState from "use-local-storage-state";
import type { View } from "../../common/types.ts";
import { SafeHtml } from "./SafeHtml.tsx";

export const OffseasonChanges = ({ changes }: { changes: View<"seasonPreview">["offseasonChanges"] }) => {
	const [minOvr, setMinOvr] = useLocalStorageState("offseasonChangesMinOvr", { defaultValue: 60 });
	const notable = changes.filter((change) => change.isWatchList || change.ovr >= minOvr || change.score >= 15);
	return (
		<section className="mt-3 mb-4">
			<h2>Notable Offseason Changes</h2>
			<label className="d-flex align-items-center gap-2 mb-3">
				Minimum OVR
				<input className="form-control form-control-sm" style={{ width: 85 }} type="number" min={0} value={minOvr} onChange={(event) => {
					const value = Number(event.target.value);
					if (Number.isFinite(value) && value >= 0) setMinOvr(value);
				}} />
			</label>
			{notable.length === 0 ? <p>No notable offseason moves.</p> : (
				<ul className="list-unstyled">
					{notable.map((change) => <li className="mb-3" key={change.eid}>
						{change.isWatchList ? <span className="badge text-bg-warning me-2">★ Watched</span> : null}
						<SafeHtml dirty={change.text} />
					</li>)}
				</ul>
			)}
		</section>
	);
};
